import { useNavigate, useSearchParams } from 'react-router';
import { X } from 'lucide-react';

import { useSoftwareEscrow, useSoftwareEscrowOnboarding } from 'src/context/software-escrow';
import { SoftwareOnboardingHeader, SoftwareOnboardingProgress } from 'src/components/SoftwareOnboarding';
import { AppProductTypeEnum } from 'src/graphql/schema';
import { Button } from 'src/components/ui/button';

const Header = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { totalSteps, currentStep } = useSoftwareEscrowOnboarding();
  const {
    softwareEscrow: { app },
  } = useSoftwareEscrow();

  const isEdit = searchParams.get('isEdit') === 'true';
  if (isEdit) return null;

  const onClose = () => navigate(`/applications/${app.id}`);

  return (
    <SoftwareOnboardingHeader>
      <SoftwareOnboardingProgress
        currentStep={currentStep}
        totalSteps={totalSteps}
        productType={AppProductTypeEnum.SoftwareEscrow}
      />
      <Button
        size="icon"
        variant="outline"
        className="shadow-none sm:absolute sm:top-5 sm:right-6 sm:z-2"
        onClick={onClose}
        aria-label="Close"
      >
        <X />
      </Button>
    </SoftwareOnboardingHeader>
  );
};

export default Header;
